import { Component } from "react";
import { Button, Col, Container, FormControl, FormGroup, FormText, Row } from "react-bootstrap";
import { RouteComponentProps } from "react-router";
import {

  withRouter
} from "react-router-dom";

import '../../assets/css/worldMap.scss';
import '../../assets/css/geral.scss';
import CreateMap from "../../components/CreateMap";
import noramMap from "../../utils/noramMap";
import latamMap from "../../utils/latamMap";
import emeaMap from "../../utils/emeaMap";
import apacMap from "../../utils/apacMap";
import WorldMapTeamState from "./WorldMapTeamState";
import WorldMapTeamDTO from "../../models/teamMap/WorldMapTeamDTO";
import * as worldMapTeamAction from "../../actions/teamMap/WorldMapTeamAction";
import DynatraceContactDTO from "../../models/teamMap/DynatraceContactDTO";
import * as htmlToImage from 'html-to-image';
import download from 'downloadjs';
import partnerProgramLogo from '../../assets/img/general/CloudPartnerProgramLogo.png';


class WorldMapTeam extends Component<RouteComponentProps, WorldMapTeamState>   {

  state: Readonly<WorldMapTeamState> = {
    region: this.props.match.params["region"].toUpperCase(),
    width: "90%",
    showMenu: true,
    mapInfoIsLoaded: false,
    usa: Array<WorldMapTeamDTO>(),
    canada: Array<WorldMapTeamDTO>(),
    latam: Array<WorldMapTeamDTO>(),
    emea: Array<WorldMapTeamDTO>(),
    apac: Array<WorldMapTeamDTO>(),
    partnerTeam: Array<DynatraceContactDTO>(),
    serviceTeam: Array<DynatraceContactDTO>(),
    otherTeam: Array<DynatraceContactDTO>(),
    error: false,
    imageWidth: 1700,
    isSecondaryScreen: this.props["isSecondaryScreen"],
  }

  canYouHaveAccess() {
    console.log(this.props["isSecondaryScreen"]);
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        this.props.history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

  componentDidMount() {
    this.canYouHaveAccess();
    this.getMapByRegion();
    this.getDynatraceContactsByRegion();
  }


  chooseMapToShow() {
    const { region, usa, canada, latam, emea, apac, width } = this.state;
    switch (region) {
      case "NORAM":
        return <CreateMap width={width} region={region} usa={usa.map(person => <path id={person.location} name={person.location} fill={person.dynatraceContact?.color} d={noramMap.get(person.location || "")} />)}
          canada={canada.map(person => <path id={person.location} name={person.location} fill={person.dynatraceContact?.color} d={noramMap.get(person.location || "")} />)} />;
      case "LATAM":
        return <CreateMap width={width} region={region} latam={latam.map(person => <path id={person.location} name={person.location} fill={person.dynatraceContact?.color} d={latamMap.get(person.location || "")} />)} />;
      case "EMEA":
        return <CreateMap width={width} region={region} emea={emea.map(person => <path id={person.location} name={person.location} fill={person.dynatraceContact?.color} d={emeaMap.get(person.location || "")} />)} />;
      case "APAC":
        return <CreateMap width={width} region={region} apac={apac.map(person => <path id={person.location} name={person.location} fill={person.dynatraceContact?.color} d={apacMap.get(person.location || "")} />)} />;
      case "GLOBAL":
        return <CreateMap width={width} region={region} />;
      case "CLOUD_PSM":
        return <CreateMap width={width} region={region} />;
    }

  }

  render() {
    const { mapInfoIsLoaded, error } = this.state;
    return (
      <>
        {!mapInfoIsLoaded && !error && this.getLoader()}
        {mapInfoIsLoaded && this.getLoadedMap()}
        {error && this.getError()}
      </>

    );
  }

  getLoader() {
    const { region } = this.state;
    return <div id="loader" className="m-5 p-5">
      <h2 className="text-danger text-center">LOADING Map from {region} region...</h2>
    </div>;
  }

  getError() {
    return <div id="error" className="m-5 p-5">
      <h2 className="text-danger text-center">Something Went wrong...</h2>
      <h3>Try again later, or report to partneroperations@dynatrace.com</h3>
    </div>;
  }

  getLoadedMap() {
    const { showMenu, region, serviceTeam, partnerTeam } = this.state;
    const serviceTeamNameFirst = (serviceTeam[0] && serviceTeam[0].section) ? serviceTeam[0].section.replace("LEFT", "") : "";
    const serviceTeamName = (region === "GLOBAL" || region === "CLOUD_PSM") ? serviceTeamNameFirst : region + serviceTeamNameFirst;
    return <div id="worlMap" className="m-0 dark-mode pb-5">
      {showMenu && this.showMenu()}
      <div className="mt-1 ml-2 mr-0 pb-5 mb-0" >
        <Row className="pt-5 mt-2 pl-3">
          <Col xs={12} md={6} lg={6}>
            {(region === "CLOUD_PSM") ? <h4 className="text-white">Cloud PSM MAP</h4> : <h4 className="text-white">{region} PARTNER MAP</h4>}
          </Col>
          <Col xs={12} md={2} lg={2}>
            <img src={partnerProgramLogo} width="150%" alt="partnerProgramLogo" />
          </Col>
        </Row>
        <Row className="pl-3">
          {this.getTeamHtml(serviceTeamName, serviceTeam)}
          {this.getTeamHtml(region + " PARTNER TEAM", partnerTeam)}
          <Col xs={12} md={7} lg={7}>
            {this.chooseMapToShow()}

          </Col>
        </Row>
        {this.getOtherTeam()}
      </div>
    </div>
  }

  async getMapByRegion() {
    const { region } = this.state;
    worldMapTeamAction.getMapByRegion(region).then(response => {
      const team: Array<WorldMapTeamDTO> = response.data;
      this.handleMapResponse(team, region);
    }).then(() => {
      this.setState({ mapInfoIsLoaded: true });
    }).catch(err => {
      console.error('oops, something went wrong!', err);
      this.setState({ error: true });
    });
  }

  handleMapResponse(team: Array<WorldMapTeamDTO>, region: string) {
    switch (region) {
      case "NORAM":
        this.setState({ usa: team.filter(m => m.country === "USA") });
        this.setState({ canada: team.filter(m => m.country === "CANADA" || m.location === "Alaska") });
        break;
      case "LATAM":
        this.setState({ latam: team });
        break;
      case "EMEA":
        this.setState({ emea: team });
        break;
      case "APAC":
        this.setState({ apac: team });
        break;
    }
  }

  async getDynatraceContactsByRegion() {
    const { region } = this.state;
    worldMapTeamAction.getDynatraceContactsByRegion(region).then(response => {
      const team: Array<DynatraceContactDTO> = response.data;
      console.log(response.data);
      console.log(team.filter(p => p.section?.includes("LEFT")).sort((a, b) => a.position! - b.position!));
      this.setState({ partnerTeam: team.filter(p => p.section === "PARTNER TEAM").sort((a, b) => a.position! - b.position!) });
      this.setState({ serviceTeam: team.filter(p => p.section?.includes("LEFT")).sort((a, b) => a.position! - b.position!) });
      this.setState({ otherTeam: team.filter(p => p.section?.includes("BOTTOM")).sort((a, b) => a.position! - b.position!) });
    }).catch(err => {
      console.error('oops, something went wrong!', err);
      this.setState({ error: true });
    });
  }

  // add this if you want other group in same column
  // getOtherTeam(team: Array<DynatraceContactDTO> ,region: string, section: string) {  
  //   if (region === "APAC" && section === "left-side") {
  //     return <div><h6 className="text-white">{team[0]?.section}</h6>
  //     {this.getTeam(team)}</div>
  //   } else if (region !== "APAC" && section ==="after-map") {
  //     return this.getOtherTeamHtml();
  //   }    
  // }

  getTeam(team: Array<DynatraceContactDTO>) {
    return team.map(p => this.getHtmlMemberTeam(p));
  }

  getHtmlMemberTeam(p: DynatraceContactDTO) {
    return <div style={this.getLegendStyle(p.color)}>
      <p className="font-weight-bold">{p?.name?.toUpperCase()}{(p?.description == "" || p?.description == null || p?.description == undefined) ? "" : " - " + p?.description} </p>
      <p>{p?.title}</p>
      <p>{p?.phoneNumber}</p>
      <p>{p?.email}</p>
    </div>;
  }

  getLegendStyle(color?: string) {
    return { backgroundColor: color, color: "white", padding: "5px 0px 5px 10px" }
  }

  getTeamHtml(teamName, team) {
    if (team == null || team.length === 0) {
      return null;
    }
    return <Col xs={12} md={2} lg={2} className="mt-5 ml-1 mr-0 pr-0">
      <h6 className="text-white">{teamName}</h6>
      {this.getTeam(team)}
    </Col>;
  }

  getOtherTeam() {
    const { otherTeam } = this.state;
    const col1: Array<JSX.Element> = [], col2: Array<JSX.Element> = [], col3: Array<JSX.Element> = [], col4: Array<JSX.Element> = [];

    otherTeam.forEach((p, index) => {
      const position = p.position || 0;
      if (position % 3 === 0) {
        col3.push(this.getHtmlMemberTeam(p));
      } else if ((position + 1) % 3 === 0) {
        col2.push(this.getHtmlMemberTeam(p));
      } else {
        col1.push(this.getHtmlMemberTeam(p));
      }
    })

    return <div>
      <Row className="mt-2 ml-0">
        <Col xs={12} md={4} lg={4} />
        <Col xs={12} md={6} lg={6}  >
          <h6 className="text-white">{otherTeam[0]?.section!.replace("BOTTOM", "")}</h6>
        </Col>
      </Row>
      <Row className="mb-3 ml-0 pl-0 pr-2 mr-2">
        <Col xs={12} md={4} lg={4} />
        <Col xs={12} md={2} lg={2} className="pr-0 pl-0"  >
          {col1}
        </Col>
        <Col xs={12} md={2} lg={2} className="pl-0 pr-0"  >
          {col2}
        </Col>
        <Col xs={12} md={2} lg={2} className="pl-0 pr-0"  >
          {col3}
        </Col>
        <Col xs={12} md={2} lg={2} className="pl-0"  >
          {col4}
        </Col>
      </Row>
    </div>
  }

  showMenu() {
    const { width, imageWidth, region, isSecondaryScreen } = this.state;
    if (isSecondaryScreen) {
      return <Container></Container>;
    }
    return <Container className="pt-5">
      <Row className="mt-2">
        <Col xs={12} md={2} lg={2}>
          <FormGroup key="group-1">
            <FormControl
              key="size%"
              value={parseFloat(width)}
              name="MapSize"
              id="MapSize"
              type="number"
              onChange={e => this.setState({ width: e.target.value + "%" })}
            />
            <FormText className="text-white">
              Map Size (Percentage)
            </FormText>
          </FormGroup>
        </Col>
        {/* <Col xs={12} md={2} lg={2}>
          <Button onClick={() => this.printMap()}>Print Map</Button>
          <FormText className="text-white">
            Print PDF with the choosen Map size
          </FormText>
        </Col> */}
        {/* <Col xs={12} md={3} lg={3}>
          <Button onClick={() => this.printMapOptimizedSize()}>Print Map (Optimized)</Button>
          <FormText className="text-white">
            The size of the map is automatically adjusted to print to pdf (85% map size)
          </FormText>
        </Col>
        <Col xs={12} md={2} lg={2}>
          <FormGroup key="group-1">
            <FormControl
              key="ImageWidth%"
              value={imageWidth}
              name="ImageWidth"
              id="ImageWidth"
              type="number"
              onChange={e => this.setState({ imageWidth: Number(e.target.value) })}
            />
            <FormText className="text-white">
              Image width (default recommended)
            </FormText>
          </FormGroup>
        </Col> */}
        <Col xs={12} md={3} lg={3}>
          <Button onClick={() => this.dowloadImage()}>Download Map</Button>
          <FormText className="text-white">
            Download image in png type
          </FormText>
        </Col>
        <Col xs={12} md={3} lg={3}>
          <Button className="ml-4 btn-secondary" href={'/world-map/edit/' + region}>Edit Team</Button>
          <Button className="ml-2 btn-secondary" href={'/world-map/edit/region/' + region}>Edit World</Button>
        </Col>
      </Row>
    </Container>
  }


  printMapOptimizedSize() {
    this.setState({ width: "85%", showMenu: false });
    this.sleep(500)
      .then(() => window.print())
      .then(() => this.setState({ width: "70%", showMenu: true }));
  }

  printMap() {
    this.setState({ showMenu: false });
    this.sleep(500)
      .then(() => window.print())
      .then(() => this.setState({ showMenu: true }));
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  dowloadImage() {
    this.setState({ showMenu: false });
    this.sleep(500)
      .then(() => this.createPng());
  }

  createPng() {
    const { region, imageWidth } = this.state;
    var node = document.getElementById('worlMap') || new HTMLElement();

    htmlToImage.toPng(node, { width: imageWidth })
      .then(function (dataUrl) {
        download(dataUrl, "map-" + region + ".png");
      })
      .then(() => this.setState({ showMenu: true }))
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
  }

}

export default withRouter(WorldMapTeam);

